import React, { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import MiDataTableSupply from './MiDataTableSupply';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Kpi from '../../componentes/ui/Kpi';
import Button from '../../componentes/ui/Button';
import { Spinner } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Modal from 'react-bootstrap/Modal';
import FormInput from '../../componentes/formulario/FormInput';
import MiSelect from '../../componentes/formulario/MiSelect';
import MiSelectMultiple from '../../componentes/formulario/MiSelectMultiple';
import GoToRunCicCfg from '../../componentes/formulario/GoToRunCicCfg';


import { alertService } from '../../services/alertservice';
import { Alert } from '../../componentes/ui/Alert';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getApiUrl, axiosPost, getPantDocFromNivel, getTitle, getDecodedCookie } from '../../helpers/helperApp';

import { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import FormRow from '../../componentes/formulario/FormRow';


$.DataTable = DataTable;

function Supply(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const source2 = CancelToken.source();
    const source3 = CancelToken.source();
    const source4 = CancelToken.source();
    const source5 = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ tableAprov, saveTableAprov ] = useState([]);
    const [ calculateData, saveCalculateData ] = useState(null);
    const [ docAprov, saveDocAprov ] = useState(null);
    const [ loadingCalculate, saveLoadingCalculate ] = useState(false);
    const [ solicitandoMat, saveSolicitandoMat ] = useState(false);
    const [ primeraCarga, savePrimeraCarga ] = useState(true);
    const [ txtBtnSolicitando, saveTxtBtnSolicitando ] = useState("");
    const [ verAprov, saveVerAprov ] = useState(false);
    const [ showModal, saveShowModal ] = useState(false);
    const [ docsori, saveDocsOri ] = useState([]);
    const [ showModalCreateAprov, saveShowModalCreateAprov ] = useState(false);
    const [ valCentroModalCreateAprov, saveValCentroModalCreateAprov ] = useState(0);
    const [ nomNewDocAprov, saveNomNewDocAprov ] = useState("");
    const [ sendingMail, saveSendingMail ] = useState(false);
    const [ showModalSendMail, saveShowModalSendMail ] = useState(false);
    const [ valResponsable, saveValResponsable ] = useState(0);
    const [ valEmails, saveValEmails ] = useState([]);    
    const [ valCiclos, saveValCiclos ] = useState(0);    


    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, adjuntosPrin, saveAdjuntosPrin, adjuntosExistentesPrin, saveAdjuntosExistentesPrin, registrosHijo,  formularioHijo, saveFormularioHijo, adjuntosHijo, saveAdjuntosHijo, adjuntosExistentesHijo, saveAdjuntosExistentesHijo, handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleEditRegHijo, handleDeleteItemPrin, handleDeleteItemHijo, handleSubmitPrin, handleSubmitHijo, resetFormPrin, resetFormHijo, handleSelectFormPrin, handleSelectFormHijo, handleSelectFormPrinAndSetValue, handleSelectFormHijoAndSetValue, handleClonePrin, handleCloneHijo } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                     
                    document.title = getTitle(confPantalla.config.trad, confPantalla.supply.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);                                                                                                        
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
                source2.cancel();
                source3.cancel();
                source4.cancel();
                source5.cancel();
        } 

    },[confPantalla, formularioHijo.id])

    const handleSearchStock = async() => {        

        saveVerAprov(false);

        saveLoadingCalculate(true);
        
        await getDocAprov();

        let table = $("#supply").DataTable();
        const rows = table.rows( { selected: true } ).data();
        if( rows.length > 0 ){

            savePrimeraCarga(false);

            const ids = [];
            rows.map( row => {                
                ids.push(row.id);
            })
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("ids", JSON.stringify(ids));
            // const respuesta = await axios.post(getApiUrl(window.location.origin)+confPantalla.supply.controles.datatableres.getdata,data);
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.supply.controles.datatableres.getdata, data, source.token);
            
            if( typeof respuesta.data !== "string" ){
                saveCalculateData(respuesta.data);
            }else if( typeof respuesta.data === "string" ){            
                // Reseteamos la tabla de aprovisionamiento
                resetTAbAprov();
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
            } 

        }else{
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.supply.controles.emptyclick.title}`,{autoClose: true});
            // Reseteamos la tabla de aprovisionamiento
            resetTAbAprov();
        }  
        
        saveLoadingCalculate(false);
        saveVerAprov(true);
    }

    const getDocAprov = async () =>{

        const data = new FormData();      
        data.append("validacion", apiKey());
        // const respuesta = await axios.post(getApiUrl(window.location.origin)+"/supply/getDocAprov",data);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+"/supply/getDocAprov", data, source3.token);

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true}); 
        }else if( respuesta.data.length == 0 ){
            // No existe documento de aprovisonamiento
            saveDocAprov(null);
        }else if( respuesta.data.length ){
            // Existe documento de aprovisionamiento     
            saveDocAprov(respuesta.data);
        }

    }

    const solicitarMateriales = async () => {

        if(docAprov == null){
            // No existe documento.
            saveNomNewDocAprov("");
            saveValCentroModalCreateAprov(0);
            saveShowModalCreateAprov(true);
        }else{
            await solicitarMaterialesCall();
        }

    }

    const solicitarMaterialesCall = async () => {
        saveShowModalCreateAprov(false);
        saveSolicitandoMat(true);        
    
        let table = $('#calcsupply').DataTable();
        const rows = table.rows().data()

        let tableDocs = $('#supply').DataTable();
        const rowsDocs = tableDocs.rows({ selected: true }).data()

        const materiales = [];
        const documentos = [];

        // Eliminamos la columna con la clase style del row de la tabla
        rows.map(row => {
            delete row.style;
            if(row.necesario > 0){
                materiales.push(row);
            }
        })

        rowsDocs.map(row => {
            delete row.style;
            documentos.push(row);
        })
        
        const data = new FormData(); 
        data.append("validacion", apiKey());
        data.append("datos", JSON.stringify(materiales));
        data.append("datos2", JSON.stringify(documentos));
        if(docAprov == null){
            // No existe documento.
            data.append("nomnewdocapro", nomNewDocAprov);
            data.append("idcen", valCentroModalCreateAprov);
        }

        // Crear cabecera/linea
        saveTxtBtnSolicitando(confPantalla.supply.controles.btnsolicitudsendingreg.title);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.supply.controles.sendmaterialesreg.senddata, data, source2.token);
        if( typeof respuesta.data.ok === "string"  ){
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.supply.controles.sendmaterialesreg.success.title}`, {autoClose: true});

            // Recargamos la información del documento de aprovisionamiento
            await getDocAprov();

            // Reseteamos la tabla de aprovisionamiento
            resetTAbAprov();

        }else if( respuesta.data === false ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.supply.controles.sendmaterialesreg.error.title}`, {autoClose: true});            
        }else if( typeof respuesta.data === "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});  
        }

        saveSolicitandoMat(false);
    }

    const sendMail = () => {
        saveValResponsable(docAprov[0]["idage2"]);
        saveValEmails([]);
        saveShowModalSendMail(true);
    }

    const sendMailCall = async () => {
        saveSendingMail(true);        

        const documentos = [];        
        let tableDocs = $('#supply').DataTable();
        const rowsDocs = tableDocs.rows({ selected: true }).data()        
        rowsDocs.map(row => {
            delete row.style;
            documentos.push(row);
        })

        const data = new FormData(); 
        data.append("validacion", apiKey());                
        data.append("idaprov", docAprov[0]["iddocaprov"]);
        data.append("idage2", valResponsable);
        data.append("idsusu", valEmails.join(','));

        // Envío de correo
        // saveTxtBtnSolicitando(confPantalla.supply.controles.btnsolicitudsendingmail.title);
        const respuestamail = await axiosPost(getApiUrl(window.location.origin)+confPantalla.supply.controles.sendmaterialesmail.senddata, data, source4.token);
        if( typeof respuestamail.data.ok === "string"  ){
            alertService.success(`${respuestamail.data.ok}`, {autoClose: false});
            // Recargamos la información del documento de aprovisionamiento
            await getDocAprov();
        }else if( respuestamail.data === false ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.supply.controles.sendmaterialesmail.error.title}`, {autoClose: true});            
        }else if( typeof respuestamail.data === "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuestamail.data}`, {autoClose: true});  
        }

        saveShowModalSendMail(false);
        saveSendingMail(false);
    }


    // Función para resetear la tabla de aprovisionamiento
    const resetTAbAprov = () => {
        saveLoadingCalculate(true);
        saveVerAprov(false); 
        saveCalculateData([])
        saveVerAprov(true);
        saveLoadingCalculate(false);
    }
    
    // Función para ver los documentos de orígen de las líneas de la tabla de aprovisionamiento
    const verOrigenes = async (e, rowData) => {

        const data = new FormData(); 
        data.append("validacion", apiKey());
        data.append("iddocs", rowData.iddocs);
        data.append("iduni", rowData.id);

        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.supply.controles.getdocsaprov, data, source5.token);
        if( typeof respuesta.data === "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});  
        }else{
            saveDocsOri(respuesta.data)
            saveShowModal(true);
        }


    }

    const loadOptionsCboCiclos = async (url, saveOptions, saveLoading) =>{
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idtip", docAprov[0]["idtip"]);                                                      
        const respuesta = await axios.post(getApiUrl(window.location.origin)+url, data);
        saveOptions(respuesta.data);
        if(respuesta.data.length == 1){
            saveValCiclos(respuesta.data[0]["value"]);
        }
        saveLoading(true);
    }

    const handleInput = (e, save) => {        
        save(e.target.value)
    }

    const handleSelect= (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleSelectMultiple = (selectedItem, nameOfComponent, saveData) => {
        let optionsSeleccionadas = [];        
        
        for(let i = 0; i < selectedItem.length; i++){
            optionsSeleccionadas.push(selectedItem[i].value);
        }
        
        if( selectedItem ){
            saveData(optionsSeleccionadas);
        }else{            
            saveData([]);
        }
    }

    return(
        <div className="App wrapper">   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Alert fondo={true} />
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">                
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section titulo={ confPantalla.supply.section.titulo } icono={ confPantalla.supply.section.icono } col={ confPantalla.supply.section.col } >

                                <Kpi
                                    conf={ confPantalla.supply.controles.kpi }
                                    getDataTable1 = { confPantalla.supply.controles.datatable.getdata }
                                    saveDataTable1 = { saveTableAprov }                           
                                    saveLoadingTable = { saveLoadingTable }
                                    filtro={ confPantalla.supply.controles.tipdoc }
                                    idFiltro={ 0 }
                                    resetCalcsupply={ true }
                                    callBackLoaded={ resetTAbAprov }
                                    initLoading={ resetTAbAprov }
                                />                            
                                <MiDataTable 
                                    estadoForm= { "" }
                                    formulario={ {id:0} }
                                    id={"supply"}
                                    columnas={confPantalla.supply.controles.datatable.columns}
                                    data={tableAprov}
                                    buttons={confPantalla.supply.controles.datatable.buttons}
                                    ordering={confPantalla.supply.controles.datatable.ordering}
                                    order={confPantalla.supply.controles.datatable.order}
                                    searching={confPantalla.supply.controles.datatable.searching}
                                    paging={confPantalla.supply.controles.datatable.paging}
                                    select={confPantalla.supply.controles.datatable.select}
                                    pagelength={confPantalla.supply.controles.datatable.pagelength}
                                    // saveLoadingTable={ saveLoadingTable }
                                    loadingTable={loadingTable}
                                    columnactions={confPantalla.supply.controles.datatable.columnactions.title}
                                    linkColumns={confPantalla.supply.controles.datatable.linkColumns}
                                    traduction={confPantalla.config.trad.components.datatable}                                        
                                />
                                {
                                    tableAprov.length > 0
                                    ?
                                        <Fragment>
                                            <Button 
                                                clases={ "col-12 mt-2" }
                                                color={ "success" }  
                                                type="button" 
                                                icono={ "" }   
                                                id="btncalcaprov"     
                                                texto={ confPantalla.supply.controles.btncalcular.title }   
                                                accion={ handleSearchStock } 
                                                disabled={ false }
                                            />                            
                                            <p className="font-italic text-center">{ confPantalla.supply.controles.texthelpcalcular.title }</p>
                                        </Fragment>
                                    :
                                        null
                                }
                                {   loadingCalculate ? 
                                        <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                            <Spinner animation="border" />
                                        </div>
                                    :
                                    null
                                }
                                {
                                    calculateData != null && primeraCarga == false
                                    ?
                                        <Fragment>
                                            <Tabs defaultActiveKey="tab1" id="tab1">
                                                <Tab eventKey="tab1" title={ confPantalla.supply.tabs.tab1.titulo }>
                                                    {
                                                        verAprov                                                         
                                                        ?
                                                            <MiDataTableSupply 
                                                                estadoForm= { "" }
                                                                formulario={ {id:0} }
                                                                id={"calcsupply"}
                                                                columnas={confPantalla.supply.controles.datatableres.columns}
                                                                data={calculateData}
                                                                saveData={saveCalculateData}
                                                                buttons={confPantalla.supply.controles.datatableres.buttons}
                                                                ordering={confPantalla.supply.controles.datatableres.ordering}
                                                                order={confPantalla.supply.controles.datatableres.order}
                                                                searching={confPantalla.supply.controles.datatableres.searching}
                                                                paging={confPantalla.supply.controles.datatableres.paging}
                                                                select={confPantalla.supply.controles.datatableres.select}
                                                                pagelength={confPantalla.supply.controles.datatableres.pagelength}
                                                                saveLoadingTable={ saveLoadingCalculate }
                                                                loadingTable={loadingCalculate}
                                                                columnactions={confPantalla.supply.controles.datatableres.columnactions.title}
                                                                linkColumns={confPantalla.supply.controles.datatableres.linkColumns}
                                                                traduction={confPantalla.config.trad.components.datatable}
                                                                functionClickTd={verOrigenes}                                        
                                                            />                                           
                                                        :
                                                            null
                                                    }
                                                </Tab>
                                                <Tab eventKey="tab" title={ confPantalla.supply.tabs.tab2.titulo }>
                                                    {
                                                        docAprov == null
                                                        ?
                                                            <div className='text-center mt-4 mb-4'>
                                                                <i className="fal fa-empty-set fa-6x" style={{color: "#dc3545"}}></i>                                                                
                                                            </div>
                                                        :
                                                            <Fragment>
                                                                
                                                                <NavLink to={getPantDocFromNivel(getDecodedCookie('nivel'), true)+"/"+docAprov[0]["iddocaprov"]}>
                                                                    {/* <hr data-content={docAprov[0]["nomdoc"]}
                                                                        className="hr-titleinfwhite">                                                                    
                                                                    </hr> */}
                                                                    <div class="alert alert-secondary text-center" role="alert">
                                                                            <h4 dangerouslySetInnerHTML={{ __html: docAprov[0]["nomdoc"] }}></h4>
                                                                    </div>
                                                                </NavLink>                                                               
                                                                <button 
                                                                    type="button" 
                                                                    onClick={ sendMail } 
                                                                    className="btn btn-flat btn-primary col-2 mb-1 mr-1 mt-1" 
                                                                    disabled={ sendingMail ? true : false } 
                                                                >                                                                                                                                                                                       
                                                                    {   
                                                                        sendingMail
                                                                        ? 
                                                                            <Spinner as="span" animation="border" size="sm" />
                                                                        :
                                                                            <Fragment>
                                                                                <i className="fal fa-inbox-out md-1"></i>
                                                                                <span className='pl-1'>{confPantalla.supply.controles.btncomunicar.title }</span>    
                                                                            </Fragment>
                                                                    }
                                                                </button>                                                                
                                                                <GoToRunCicCfg 
                                                                    idDoc={docAprov != null ? docAprov[0]["iddocaprov"] : 0}
                                                                    flatBtn={true}
                                                                    infoDocActual={docAprov[0]}
                                                                    origenProp={"supply"}
                                                                />
                                                                <MiDataTable 
                                                                    estadoForm= { "" }
                                                                    formulario={ {id:0} }
                                                                    id={"docaprov"}
                                                                    columnas={confPantalla.supply.controles.datatableaprov.columns}
                                                                    data={docAprov}
                                                                    buttons={confPantalla.supply.controles.datatableaprov.buttons}
                                                                    ordering={confPantalla.supply.controles.datatableaprov.ordering}
                                                                    order={confPantalla.supply.controles.datatableaprov.order}
                                                                    searching={confPantalla.supply.controles.datatableaprov.searching}
                                                                    paging={confPantalla.supply.controles.datatableaprov.paging}
                                                                    select={confPantalla.supply.controles.datatableaprov.select}
                                                                    pagelength={confPantalla.supply.controles.datatableaprov.pagelength}
                                                                    // saveLoadingTable={ saveLoadingCalculate }
                                                                    // loadingTable={loadingCalculate}
                                                                    columnactions={confPantalla.supply.controles.datatableaprov.columnactions.title}
                                                                    linkColumns={confPantalla.supply.controles.datatableaprov.linkColumns}
                                                                    traduction={confPantalla.config.trad.components.datatable}                                        
                                                                />
                                                            </Fragment>
                                                    }

                                                </Tab>
                                            </Tabs>
                                            <button 
                                                type="button" 
                                                onClick={ solicitarMateriales } 
                                                className="btn btn-flat btn-danger col-12 mt-2 mb-4" 
                                                disabled={ calculateData.length == 0 || !calculateData || solicitandoMat || loadingCalculate? true : false } 
                                            >
                                                {
                                                    solicitandoMat 
                                                    ?                                                         
                                                        txtBtnSolicitando 
                                                    :
                                                        confPantalla.supply.controles.btnsolicitud.title 
                                                }                                                
                                                {   
                                                    solicitandoMat
                                                    ? 
                                                    <Spinner as="span" style={{marginLeft: "10px"}} animation="border" size="sm" />
                                                    :
                                                    null
                                                }      
                                            </button>
                                        </Fragment>
                                    :
                                        null
                                }
                                <Modal
                                    show={showModal}
                                    onHide={ () => saveShowModal(false)}                            
                                    aria-labelledby="example-custom-modal-styling-title"
                                    centered={true}                    
                                    dialogClassName="modal-90w"                                             
                                > 
                                    <Modal.Header closeButton>
                                    </Modal.Header>                         
                                    <Modal.Body>
                                        <MiDataTable 
                                            estadoForm= { "" }
                                            formulario={ {id:0} }
                                            id={"docsori"}
                                            columnas={confPantalla.supply.controles.datatabledocsaprov.columns}
                                            data={docsori}
                                            buttons={confPantalla.supply.controles.datatabledocsaprov.buttons}
                                            ordering={confPantalla.supply.controles.datatabledocsaprov.ordering}
                                            order={confPantalla.supply.controles.datatabledocsaprov.order}
                                            searching={confPantalla.supply.controles.datatabledocsaprov.searching}
                                            paging={confPantalla.supply.controles.datatabledocsaprov.paging}
                                            select={confPantalla.supply.controles.datatabledocsaprov.select}
                                            pagelength={confPantalla.supply.controles.datatabledocsaprov.pagelength}
                                            saveLoadingTable={ saveLoadingTable }
                                            loadingTable={loadingTable}
                                            columnactions={confPantalla.supply.controles.datatabledocsaprov.columnactions.title}
                                            linkColumns={confPantalla.supply.controles.datatabledocsaprov.linkColumns}
                                            traduction={confPantalla.config.trad.components.datatable}                                        
                                        />
                                    </Modal.Body>                            
                                </Modal>
                                <Modal
                                    show={showModalCreateAprov}
                                    onHide={ () => saveShowModalCreateAprov(false)}                            
                                    aria-labelledby="example-custom-modal-styling-title"
                                    centered={true}                    
                                    dialogClassName="modal-90w"                                             
                                > 
                                    <Modal.Header closeButton>
                                        <h4>{confPantalla.supply.controles.modalcreateaprov.header.title}</h4>
                                    </Modal.Header>                         
                                    <Modal.Body>
                                        <FormRow>
                                            <MiSelect  
                                                estadoForm=  { "" }
                                                val=         { valCentroModalCreateAprov }   
                                                loading=     { loadReg ? true : false }
                                                id=          { confPantalla.supply.controles.modalcreateaprov.idcen.id }    
                                                name=        { confPantalla.supply.controles.modalcreateaprov.idcen.name }   
                                                label=       { confPantalla.supply.controles.modalcreateaprov.idcen.label }    
                                                placeholder= { confPantalla.supply.controles.modalcreateaprov.idcen.placeholder }
                                                col=         { confPantalla.supply.controles.modalcreateaprov.idcen.col } 
                                                isClearable= { confPantalla.supply.controles.modalcreateaprov.idcen.isclearable }
                                                isSearchable={ confPantalla.supply.controles.modalcreateaprov.idcen.issearchable }
                                                dataType=    { confPantalla.supply.controles.modalcreateaprov.idcen.datatype }
                                                data=        { confPantalla.supply.controles.modalcreateaprov.idcen.data }
                                                required=    { confPantalla.supply.controles.modalcreateaprov.idcen.required } 
                                                disabled=  { confPantalla.supply.controles.modalcreateaprov.idcen.disabled }
                                                readOnly =   { confPantalla.supply.controles.modalcreateaprov.idcen.readonly }
                                                disablethisid={confPantalla.supply.controles.modalcreateaprov.idcen.disablethisid}
                                                disableids={ confPantalla.supply.controles.modalcreateaprov.idcen.disableids}
                                                formulario= { {id:0} }   
                                                change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValCentroModalCreateAprov) }
                                            />
                                            <FormInput                                                        
                                                estadoForm= { "" }
                                                value=      { nomNewDocAprov }
                                                loading=    { false }
                                                id=         { confPantalla.supply.controles.modalcreateaprov.nom1.id }   
                                                type=       { confPantalla.supply.controles.modalcreateaprov.nom1.type }  
                                                name=       { confPantalla.supply.controles.modalcreateaprov.nom1.name }   
                                                label=      { confPantalla.supply.controles.modalcreateaprov.nom1.label }                                                       
                                                placeholder={ confPantalla.supply.controles.modalcreateaprov.nom1.placeholder }    
                                                col=        { confPantalla.supply.controles.modalcreateaprov.nom1.col } 
                                                required=   { confPantalla.supply.controles.modalcreateaprov.nom1.required }
                                                readonly=   { confPantalla.supply.controles.modalcreateaprov.nom1.readonly }                                                
                                                disabled=   { confPantalla.supply.controles.modalcreateaprov.nom1.disabled }
                                                change=     { e => handleInput(e, saveNomNewDocAprov) }
                                                onBlur=     {null} 
                                            />
                                        </FormRow>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className='text-right'>
                                            <button 
                                                    className="btn btn-success mt-1 mr-1"
                                                    onClick={ () => solicitarMaterialesCall() }
                                                    disabled={nomNewDocAprov == "" || valCentroModalCreateAprov == 0 ? true : false}                                        
                                            >
                                                {confPantalla.supply.controles.modalcreateaprov.btncrear.title}
                                            </button>
                                            <button 
                                                    className="btn btn-danger mt-1"
                                                    onClick={ () => saveShowModalCreateAprov(false) }                                        
                                            >
                                                {confPantalla.supply.controles.modalcreateaprov.btncancelar.title}
                                            </button>                                            
                                        </div>
                                    </Modal.Footer>                            
                                </Modal>
                                <Modal
                                    show={showModalSendMail}
                                    onHide={ () => saveShowModalSendMail(false)}                            
                                    aria-labelledby="example-custom-modal-styling-title"
                                    centered={true}                    
                                    dialogClassName="modal-90w"                                             
                                > 
                                    <Modal.Header closeButton>
                                        <h4>{confPantalla.supply.controles.modalsendmail.header.title}</h4>
                                    </Modal.Header>                         
                                    <Modal.Body>
                                        <MiSelect  
                                            estadoForm=  { "" }
                                            val=         { valResponsable }   
                                            loading=     { loadReg ? true : false }
                                            id=          { confPantalla.supply.controles.modalsendmail.idage2.id }    
                                            name=        { confPantalla.supply.controles.modalsendmail.idage2.name }   
                                            label=       { confPantalla.supply.controles.modalsendmail.idage2.label }    
                                            placeholder= { confPantalla.supply.controles.modalsendmail.idage2.placeholder }
                                            col=         { confPantalla.supply.controles.modalsendmail.idage2.col } 
                                            isClearable= { confPantalla.supply.controles.modalsendmail.idage2.isclearable }
                                            isSearchable={ confPantalla.supply.controles.modalsendmail.idage2.issearchable }
                                            dataType=    { confPantalla.supply.controles.modalsendmail.idage2.datatype }
                                            data=        { confPantalla.supply.controles.modalsendmail.idage2.data }
                                            required=    { confPantalla.supply.controles.modalsendmail.idage2.required } 
                                            disabled=  { confPantalla.supply.controles.modalsendmail.idage2.disabled }
                                            readOnly =   { confPantalla.supply.controles.modalsendmail.idage2.readonly }
                                            disablethisid={confPantalla.supply.controles.modalsendmail.idage2.disablethisid}
                                            disableids={ confPantalla.supply.controles.modalsendmail.idage2.disableids}
                                            formulario= { {id:0} }   
                                            change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValResponsable) }
                                        />
                                        <MiSelectMultiple  
                                            estadoForm=  { "" }
                                            val=         { valEmails }   
                                            loading=     { loadReg ? true : false }
                                            id=          { confPantalla.supply.controles.modalsendmail.emails.id }    
                                            name=        { confPantalla.supply.controles.modalsendmail.emails.name }   
                                            label=       { confPantalla.supply.controles.modalsendmail.emails.label }    
                                            placeholder= { confPantalla.supply.controles.modalsendmail.emails.placeholder }
                                            col=         { confPantalla.supply.controles.modalsendmail.emails.col } 
                                            isClearable= { confPantalla.supply.controles.modalsendmail.emails.isclearable }
                                            isSearchable={ confPantalla.supply.controles.modalsendmail.emails.issearchable }
                                            dataType=    { confPantalla.supply.controles.modalsendmail.emails.datatype }
                                            data=        { confPantalla.supply.controles.modalsendmail.emails.data }
                                            required=    { confPantalla.supply.controles.modalsendmail.emails.required } 
                                            disabled=  { confPantalla.supply.controles.modalsendmail.emails.disabled }
                                            readOnly =   { confPantalla.supply.controles.modalsendmail.emails.readonly }
                                            disablethisid={confPantalla.supply.controles.modalsendmail.emails.disablethisid}
                                            disableids={ confPantalla.supply.controles.modalsendmail.emails.disableids}
                                            formulario= { {id:0} }   
                                            change= { (selectedItem, nameOfComponent) => handleSelectMultiple(selectedItem, nameOfComponent, saveValEmails) }
                                        />
                                        
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <div className='text-right'>
                                            <button 
                                                    className="btn btn-success mt-1 mr-1"
                                                    onClick={ () => sendMailCall() }
                                                    disabled={valResponsable == 0 || valEmails.length === 0 ? true : false}                                        
                                            >
                                                {confPantalla.supply.controles.modalsendmail.btnaceptar.title}
                                            </button>
                                            <button 
                                                    className="btn btn-danger mt-1"
                                                    onClick={ () => saveShowModalSendMail(false) }                                        
                                            >
                                                {confPantalla.supply.controles.modalsendmail.btncancelar.title}
                                            </button>                                            
                                        </div>
                                    </Modal.Footer>                            
                                </Modal>                                
                            </Section>
                            
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>                                    
        </div>
        <Footer />        
        </div>

    );

}
export default Supply